import { useNavigate } from 'react-router-dom';

const footerLinks = [
  {
    title: 'Hızlı Erişim',
    links: [
      { label: 'Anasayfa', href: '/' },
      { label: 'Hizmetlerimiz', href: '/hizmetlerimiz' },
      { label: 'Neden Biz?', href: '/neden-biz' },
      { label: 'Referanslar', href: '/referanslar' },
      { label: 'İletişim', href: '/iletisim' },
    ],
  },
  {
    title: 'Hizmetlerimiz',
    links: [
      { label: 'Parsiyel Taşımacılık', href: '/hizmetlerimiz/parsiyel' },
      { label: 'Komple Araç', href: '/hizmetlerimiz/komple-arac' },
      { label: 'Ev & Ofis Taşıma', href: '/hizmetlerimiz/ev-ofis-tasima' },
      { label: 'Hızlı Kargo', href: '/hizmetlerimiz/hizli-kargo' },
      { label: 'Fiyat Teklifi', href: '/iletisim' },
    ],
  },
];

export default function Footer() {
  const navigate = useNavigate();

  return (
    <footer className="bg-gray-950 border-t border-gray-800">
      {/* Main Footer */}
      <div className="max-w-7xl mx-auto px-4 md:px-6 py-14 md:py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-10">
          {/* Brand Column */}
          <div className="lg:col-span-2">
            <img
              src="/media/54ce48c6-48b8-4db5-a1ba-60786d9cb830_TL-7ee2f101b8.png"
              alt="Töle Lojistik"
              className="h-11 w-auto object-contain mb-5 brightness-0 invert"
            />
            <p className="text-gray-500 text-sm leading-relaxed max-w-sm mb-6">
              Türkiye ile Almanya arasında 8+ yıllık deneyimle güvenilir, hızlı ve profesyonel lojistik çözümler sunuyoruz. Her zaman yanınızdayız.
            </p>

            {/* Contact info */}
            <div className="space-y-2 mb-6">
              <a href="tel:+905322376576" className="flex items-center gap-2 text-sm text-gray-400 hover:text-white transition-colors cursor-pointer group">
                <span className="w-4 h-4 flex items-center justify-center text-brand-orange">
                  <i className="ri-phone-line text-sm"></i>
                </span>
                🇹🇷 +90 532 237 65 76
              </a>
              <a href="mailto:Mustafa@tolelojistik.com.tr" className="flex items-center gap-2 text-sm text-gray-400 hover:text-white transition-colors cursor-pointer">
                <span className="w-4 h-4 flex items-center justify-center text-brand-orange">
                  <i className="ri-mail-line text-sm"></i>
                </span>
                Mustafa@tolelojistik.com.tr
              </a>
              <a href="mailto:serkan@tolelojistik.com.tr" className="flex items-center gap-2 text-sm text-gray-400 hover:text-white transition-colors cursor-pointer">
                <span className="w-4 h-4 flex items-center justify-center text-brand-orange">
                  <i className="ri-mail-line text-sm"></i>
                </span>
                serkan@tolelojistik.com.tr
              </a>
            </div>

            <div className="flex items-center gap-2.5">
              <a
                href="https://wa.me/905322376576"
                target="_blank"
                rel="nofollow noreferrer"
                className="w-9 h-9 flex items-center justify-center rounded-md bg-whatsapp/15 text-whatsapp hover:bg-whatsapp hover:text-white border border-whatsapp/20 transition-all cursor-pointer"
              >
                <i className="ri-whatsapp-line text-base"></i>
              </a>
              <a
                href="https://www.instagram.com/tolelojistik"
                target="_blank"
                rel="nofollow noreferrer"
                className="w-9 h-9 flex items-center justify-center rounded-md bg-white/5 text-gray-400 hover:text-white border border-white/10 hover:border-white/30 transition-all cursor-pointer"
              >
                <i className="ri-instagram-line text-base"></i>
              </a>
              <a
                href="mailto:Mustafa@tolelojistik.com.tr"
                className="w-9 h-9 flex items-center justify-center rounded-md bg-white/5 text-gray-400 hover:text-white border border-white/10 hover:border-white/30 transition-all cursor-pointer"
              >
                <i className="ri-mail-line text-base"></i>
              </a>
            </div>
          </div>

          {/* Links Columns */}
          {footerLinks.map((group) => (
            <div key={group.title}>
              <h4 className="text-white font-semibold text-xs uppercase tracking-[0.15em] mb-5">
                <a id={group.title.toLowerCase().replace(/ /g, '-')} href={`#${group.title.toLowerCase().replace(/ /g, '-')}`} className="cursor-pointer">{group.title}</a>
              </h4>
              <ul className="space-y-2.5">
                {group.links.map((link) => (
                  <li key={link.label}>
                    <button
                      onClick={() => navigate(link.href)}
                      className="text-gray-500 text-sm hover:text-gray-200 transition-colors cursor-pointer flex items-center gap-1.5 group bg-transparent border-none text-left"
                    >
                      <span className="w-0 h-0.5 bg-brand-orange group-hover:w-3 transition-all duration-200 flex-shrink-0"></span>
                      {link.label}
                    </button>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>
      </div>

      {/* Bottom Bar */}
      <div className="border-t border-gray-800">
        <div className="max-w-7xl mx-auto px-4 md:px-6 py-5 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-gray-600 text-xs">
            &copy; {new Date().getFullYear()} Töle Lojistik. Tüm hakları saklıdır.
          </p>
          <div className="flex items-center gap-2 text-xs">
            <span className="w-1.5 h-1.5 bg-brand-orange rounded-full animate-pulse"></span>
            <span className="text-gray-600">7/24 Aktif:</span>
            <a href="tel:+905322376576" className="text-gray-400 font-semibold hover:text-white transition-colors cursor-pointer whitespace-nowrap">
              +90 532 237 65 76
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}
